<template>
  <div class="destino">
    <label class="font-weight-bold" for="destino">Destino</label>
    <select v-model="destino" class="pointer" name="destino" id="destino">
      <option value="">Seleccione...</option>
      <option v-for="item in sucursales" :value="item">{{item.nombre | upper}}</option>
    </select>
    <i class="bar"></i>
  </div>
</template>

<script>
  export default {
    name: "Destino",
    created() {
      this.$store.dispatch("loadSucursal")
    },
    computed: {
      destino: {
        get() {
          return this.$store.state.generarGuia.filtros.destino
        },
        set(value) {
          this.$store.commit("generarGuia/SET_FILTRO", {key: "destino", value})
          this.$store.dispatch("generarGuia/getCarroGuia")
          this.$store.commit("generarGuia/UPDATE_STATE_KEY", {key: "carroPaso", data: []})
        }
      },
      sucursales() {
        return this.$store.getters.sucursales
      }
    }
  }
</script>

<style scoped>

</style>
